<template>
	<b-card class="mb-3">
			<b-container fluid class="inmobilevPadding">
				<!-- {{newarrivalProduct}} -->
				<b-row>
					<b-col class="col-md-12 col-sm-12 col-xs-12 inmobilevPadding">
						<div class="container-box">
							<b-row class="mt-4 mb-2 px-3">
								<b-col lg="6" class="text-left  d-none d-md-block">
									<span class="mr-2">Show</span>
									<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
									</b-form-select>
								
								</b-col>
								<b-col lg="4" offset-md="2">
									<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
										<b-input-group size="sm">
											<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
											</b-form-input>
											<b-input-group-append>
												<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
											</b-input-group-append>
										</b-input-group>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="px-3 pt-3"> 
								<b-col lg="12">
									<!-- <b-table show-empty sticky-header id="my-table" stacked="md" :items="newarrivalProduct" :fields="fieldsbank" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"> -->
									
									<b-table show-empty sticky-header id="my-table"  :stacked="[{'md' : stackedIs}]" :items="newarrivalProduct" :fields="fieldsbank" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									
									
								<template v-slot:cell(image)="rowImage">
									<b-img v-bind="thumbnailProps" rounded alt="" v-if="rowImage.value==''" :src="$root.MEDIAPATH+'blank.jpg'">{{rowImage}}</b-img>
									<b-img-lazy v-bind="thumbnailProps" rounded alt="" v-else :src="$root.MEDIAAPI+'toolimage/get_image?size=120x120&src='+rowImage.value">{{rowImage}}</b-img-lazy>
									
									<p class="d-block d-sm-block d-md-none"> 
										<ul class="p-0">
											<li style="height:15px;"><small>{{'Seller : '+rowImage.item.shopname}}</small></li>
											<li><small>{{'Brand : '+rowImage.item.brand}}</small></li>
											<li>
											<product-rating :userrating="rowImage.item.total_rating" style="width:100%;"></product-rating>
											</li>
											<li>
												<b-link class="create-list-cta d-flex align-items-center"			v-b-modal="'create-list-modal'" @click="$root.updateShareshop(rowImage.item),$root.sharepopup()" >
										<div class="icon-wrapper d-flex flex-column justify-content-center align-items-center mr-2"
										> <b-icon icon="plus"></b-icon>	</div><span>Create List</span> </b-link>
											</li>
										</ul>								  
									</p>

								</template>
								<template v-slot:cell(title)="rowTitle">
									<div class="titleP">
									{{rowTitle.value}}
									</div>
									<p class="d-none d-md-block">
										<ul class="p-0 ">
											<li style="height:15px;"><small>{{'Seller : '+rowTitle.item.shopname}}</small></li>
											<li><small>{{'Brand : '+rowTitle.item.brand}}</small></li>
											<li>
											<product-rating :userrating="rowTitle.item.total_rating" style="width:45%;"></product-rating>
											</li>
											<li>
												<b-link class="create-list-cta d-flex align-items-center"			v-b-modal="'create-list-modal'" @click="$root.updateShareshop(rowTitle.item),$root.sharepopup()" >
										<div class="icon-wrapper d-flex flex-column justify-content-center align-items-center mr-2"
										> <b-icon icon="plus"></b-icon>	</div><span>Create List</span> </b-link>
											</li>
										</ul>
									</p>
									<ul class="p-0 d-block d-sm-block d-md-none">
										<li>Price:<strong>{{$root.currency()+$root.tofixed((rowTitle.item.price ), 2)}}</strong></li>
										<li>Special Price: <strong>{{$root.currency()+$root.tofixed((rowTitle.item.special_price ), 2)}}</strong></li>
										<li>
										Commission: <strong>{{rowTitle.item.commission?rowTitle.item.commission+'%':'0%'}}</strong>
										
										</li>
										<li>
										Discount: <strong>{{rowTitle.item.discount?rowTitle.item.discount+'%':'0%'}}</strong>
										</li>
										  <shareicon-button :productData="rowTitle.item"  iamin="myshop"></shareicon-button>
									</ul>	
								</template>

								<template v-slot:cell(price)="rowPrice">
									{{$root.currency()+$root.tofixed((rowPrice.item.price ), 2)}}
									 <shareicon-button :productData="rowPrice.item"  iamin="myshop"></shareicon-button>
								</template>
								<template v-slot:cell(special_price)="rowPricesp">
									{{$root.currency()+$root.tofixed((rowPricesp.item.special_price ), 2)}}
								</template>
								
								<template v-slot:cell(actions)="row">
									<b-row class="float-right">
										<b-col>
										
										<b-button pill variant="primary" class="mr-1 icon-btn" @click="$root.updateShare(row.item)">
										<b-icon icon="shop-window" aria-hidden="true" v-b-tooltip.hover title="Add to Shop" placement="bottom"></b-icon>
										</b-button>
										
										
										<!-- <b-link class="ml-3"  @click="$root.updateShare(productData)">
	<b-icon class="addtoshopNow" icon="shop-window" aria-hidden="true" v-b-tooltip.hover title="Add to Shop" placement="bottom"></b-icon>
	</b-link> -->
											<!-- <div class="icon-btn float-left margin-right-half" @click="shareSelectedProducts(item, 'sms')">
												<img src="../../assets/sms.svg"/>
											</div>
											<div class="icon-btn float-left margin-right-half">
												<ShareNetwork
													network="facebook"
													url="https://www.alluraa.com"
													title="Say hi to user."
													description=""
													hashtags="Alluraa,test">
													<img src="../../assets/facebook.svg"/>
												</ShareNetwork>
											</div>
											<div class="icon-btn float-left margin-right-half">
												<ShareNetwork
													network="whatsapp"
													url="https://www.alluraa.com"
													title="New Test Alluraa Product."
													description="Test description">
													<img src="../../assets/whatsapp.svg"/>
												</ShareNetwork>
											</div>
											<div class="icon-btn float-left margin-right-half">
												<ShareNetwork
													network="twitter"
													url="https://www.alluraa.com"
													title="New Test Alluraa Product."
													hashtags="Alluraa,test"
													twitter-user="">
													<img src="../../assets/twitter.svg"/>
												</ShareNetwork>
											</div> -->
										</b-col>
									</b-row>
								</template>
									</b-table>
								</b-col>
							</b-row>
							<b-row class="px-3">
								<b-col lg="6" class="text-left">
									<span class="mr-2">Showing {{currentPage}} to {{(perPage>newarrivalProduct.length)?newarrivalProduct.length:perPage}} of {{newarrivalProduct.length}} entries</span>
								</b-col>
								<b-col lg="3" offset-md="3">
									<b-pagination v-model="currentPage" pills :total-rows="newarrivalProduct.length" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
								</b-col>
							</b-row>
						</div>
					</b-col>
				</b-row>
			</b-container>
				
		</b-card>
				
				
</template>
<script>
//import CartVariant from "@/components/cartVariant.vue";
import ProductRating from "@/components/product-rating.vue";
//import SharePopup from "@/components/agent/share-popup.vue";
import ShareiconButton from "@/components/shareiconButton.vue";
export default {
  name: 'Newarrival',
  components: {
  //"cart-variant": CartVariant,
    "product-rating": ProductRating,
	/*"share-popup": SharePopup,*/
	"shareicon-button": ShareiconButton,
  },
  props: {
   newarrivalProduct: { type: Array },
   stackedIs:{type: Boolean}
    /* cartData: { type: Object  },
	cartTotalqty:Number,*/
  },
  mounted(){
  //this.inLodcard;
  this.inLodcard();
  },
  computed: {
    
  },
  data() {
    return{
		//urlSavebank:this.$root.WEBURL+'savebankProfile',
		urlSavebank: this.$root.NEWAPIURL+'profileapi/save-bank',
		urlLoadbank: this.$root.NEWAPIURL+'profileapi/load-bannk',
		deleteUrl: this.$root.WEBAPI+'sellerapi/bank-delete',
		noAddaccount:0,
		totalRows: 1,
        currentPage: 1,
		pageOptions: [10, 20, 50, 100],
		perPage: 10,
		sortBy: '',
		sortDesc: false,
		sortDirection: 'asc',
		filter: null,
		filterOn: [],
		recordsBank: [],
		fieldsbank: [
				{ key: 'image', label: 'Image', class:'text-center radiushF pricing-columnNoboder'},
					{ key: 'title', label: 'Product Title', class:' pricing-column nameOfTheClass'},
					/* { key: 'shopname', label: 'Seller'},*/
					{ key: 'price', label: 'Price', class:'text-center pricing-column colDisplaynone'},
					{ key: 'special_price', label: 'Special Price',class:'text-center pricing-column colDisplaynone'},
					{ key: 'commission', label: 'Commission', class: 'text-center pricing-column colDisplaynone',
						formatter: (value) => { 
							if(value == '' || value == 0){
								return value = '10%';
							}
							return value+'%';
						},
					},
					{ key: 'discount', label: 'Discounts', class: 'text-center pricing-columnNoboder colDisplaynone',
						formatter: (value) => { 
							if(value == '' || value == 0){
								return value = '0%';
							}
							return value+'%';
						},
					},
					/*{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' } */
			],
			
			 
			 thumbnailProps: { blank: false, width: 120, height: 120, class: 'm1' },
    }
  },
  methods:{
	/* inLodcard(){
		alert('dasd');
	},*/
	inLodcard(){
			
			var self = this;
			
			self.recordsBank = self.newarrivalProduct;					
			self.totalRows = self.newarrivalProduct.length;
			/*
			self.axios.post(self.urlLoadbank, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error  == 0 || response.data.error == '0'){				
					self.recordsBank = response.data.result;					
					self.totalRows = self.recordsBank.length;
					//self.loading = false; 
				}else {
					//self.$root.forceLogout(response.data.message);
					self.$bvToast.toast(response.message, {
								title: 'Bank',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
						});
					
					
				}
			})
			.catch(function (error) {
				alert(error);
			});*/
			//alert('login '+self.email+" "+self.password);
		},

		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   lang="scss">


</style>
